var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M158.85 99.825c.225-2.55 0-7.65 0-7.65L171.3 75.6a77.386 77.386 0 0 0-7.65-18.45l-20.475-2.925c-1.75-1.85-3.55-3.65-5.4-5.4L134.85 28.35a76.638 76.638 0 0 0-18.45-7.65L99.825 33.15a43.415 43.415 0 0 0-7.65 0L75.6 20.7a77.403 77.403 0 0 0-18.45 7.65l-2.925 20.475c-1.85 1.75-3.65 3.55-5.4 5.4L28.35 57.15A76.65 76.65 0 0 0 20.7 75.6l12.45 16.575c-.15 2.55 0 7.65 0 7.65L20.7 116.4a77.4 77.4 0 0 0 7.65 18.45l20.475 2.925c1.75 1.9 3.55 3.7 5.4 5.4l2.925 20.475a76.626 76.626 0 0 0 18.45 7.65l16.575-12.45c2.545.225 5.105.225 7.65 0L116.4 171.3a77.383 77.383 0 0 0 18.45-7.65l2.925-20.475c1.875-1.725 5.4-5.4 5.4-5.4l20.475-2.925a76.614 76.614 0 0 0 7.65-18.45l-12.45-16.575ZM96 132a35.998 35.998 0 0 1-35.308-43.023A36 36 0 1 1 96 132Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M96 132c19.882 0 36-16.118 36-36s-16.118-36-36-36-36 16.118-36 36 16.118 36 36 36Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M137.775 48.825c1.9 1.75 3.7 3.55 5.4 5.4l20.475 2.925a77.386 77.386 0 0 1 7.65 18.45l-12.45 16.575s.225 5.1 0 7.65L171.3 116.4a76.614 76.614 0 0 1-7.65 18.45l-20.475 2.925s-3.525 3.675-5.4 5.4l-2.925 20.475a77.383 77.383 0 0 1-18.45 7.65l-16.575-12.45a43.434 43.434 0 0 1-7.65 0L75.6 171.3a76.626 76.626 0 0 1-18.45-7.65l-2.925-20.475c-1.85-1.75-3.65-3.55-5.4-5.4L28.35 134.85a77.4 77.4 0 0 1-7.65-18.45l12.45-16.575s-.15-5.1 0-7.65L20.7 75.6a76.65 76.65 0 0 1 7.65-18.45l20.475-2.925c1.75-1.85 3.55-3.65 5.4-5.4L57.15 28.35A77.403 77.403 0 0 1 75.6 20.7l16.575 12.45a43.415 43.415 0 0 1 7.65 0L116.4 20.7a76.638 76.638 0 0 1 18.45 7.65l2.925 20.475Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/Gear.2a41fe96b377b8cb8580967aaa1962e2.svg";
export { ForwardRef as ReactComponent };